import React from "react";

// Comments: A fully custom toggle replicating your sample images (green on, black off).
export function GreenSwitch({ checked, onChange, ...props }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      tabIndex={0}
      onClick={() => onChange(!checked)}
      // Outer track styling
      style={{
        width: 40,
        height: 22,
        borderRadius: 9999,
        background: checked ? "#4ade80" : "#16162c", // green on, black off
        border: "none",
        outline: "none",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        padding: 0,
        position: "relative",
        transition: "background 0.2s"
      }}
      {...props}
    >
      {/* Thumb styling */}
      <span
        style={{
          display: "block",
          width: 18,
          height: 18,
          borderRadius: "100%",
          background: "#fff",
          boxShadow: "0 1px 4px rgb(0 0 0 / 8%)",
          position: "absolute",
          top: 2,
          left: checked ? 20 : 2,
          transition: "left 0.2s"
        }}
      />
    </button>
  );
}
